import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import qs from 'qs';
import {Injectable} from '@angular/core';
import {AuthenticationService} from './authentication.service';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  // TODO needs to be set at build time - fixed in deployed bundle
  private API_URL = environment.apiUrl;

  constructor(private authenticationService: AuthenticationService) {
    this.addAuthInterceptor();
    this.addAuthRefreshInterceptor();
  }

  private addAuthInterceptor() {
    // Request interceptor to add authorization header when a token is available
    axios.interceptors.request.use(
      request => {
        // Add authorization hearder if a token is found in the store
        if (this.authenticationService.accessToken)
          request.headers['authorization'] = `Bearer ${this.authenticationService.accessToken}`;
        request.headers['Accept-version'] = 'v2';
        return request;
      },
      err => {
        console.error('interceptors.request err:', err);
        return Promise.reject(err);
      },
    );
  }

  private addAuthRefreshInterceptor() {
    createAuthRefreshInterceptor(axios, async (failedRequest) => {
      try {
        // Try refreshing the access token
        await this.authenticationService.refreshAccessToken()
        failedRequest.response.config.headers.authorization = `Bearer ${this.authenticationService.accessToken}`;
        return;
      } catch (err: any) {
        console.error('refreshAuthLogic err:', err);
        return this.authenticationService.login();
      }
    }, {
      statusCodes: [401],
      pauseInstanceWhileRefreshing: true,
    });
  }

  async get<T>(route: string, params?: string | object, axiosParams?: any) {
    try {
      const url = route.substring(0, 4) === 'http' ? new URL(route) : new URL(`${this.API_URL}/${route}`);
      if (typeof params === 'string') url.pathname = `${route}/${params}`;
      else if (typeof params === 'object') {
        url.search = qs.stringify(params);
      }
      let axiosResponse = await axios.get<T>(url.toString(), {withCredentials: true, ...axiosParams});
      return axiosResponse.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async post<T>(route: string, params?: string | any, axiosParams?: any) {
    try {
      const url = route.substring(0, 4) === 'http' ? new URL(route) : new URL(`${this.API_URL}/${route}`);
      let axiosResponse = await axios.post<T>(url.toString(), params, { withCredentials: true, ...axiosParams })
      return axiosResponse.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async patch<T>(route: string, params: string | any, axiosParams?: any) {
      try {
        const url = route.substring(0, 4) === 'http' ? new URL(route) : new URL(`${this.API_URL}/${route}`);
        let axiosResponse = await axios.patch<T>(url.toString(), params, {withCredentials: true, ...axiosParams})
        return axiosResponse.data;
      } catch (err) {
        console.error(err);
        throw err;
      }
  }

  public put(route: string, params: string | any, axiosParams: any) {
    return new Promise((resolve, reject) => {
      try {
        const url = route.substring(0, 4) === 'http' ? new URL(route) : new URL(`${this.API_URL}/${route}`);
        axios
          .put(url.toString(), params, {withCredentials: true, ...axiosParams})
          .then(resolve)
          .catch(reject);
      } catch (err) {
        reject(err);
      }
    });
  }

  public del(route: string, params: string | any, axiosParams: any) {
    return new Promise((resolve, reject) => {
      try {
        const url = route.substring(0, 4) === 'http' ? new URL(route) : new URL(`${this.API_URL}/${route}`);
        // Need this different format, otherwise the cookie is not sent
        // https://github.com/axios/axios/issues/509#issuecomment-370761888
        axios({
          url: url.toString(),
          method: 'delete',
          data: params,
          withCredentials: true,
          ...axiosParams,
        })
          .then(resolve)
          .catch(reject);
      } catch (err) {
        reject(err);
      }
    });
  }

}
